/**
 * 船内端末で、その船に配乗されていない船員がログインしたときの「乗船登録」カード。
 *
 * 端末の船に黙って乗船扱いにはせず、本人が乗船を登録してから業務を開始する。
 * 登録は船員の自己登録（/self-boarding/board）で、陸上の管理者へ必ず通知される。
 * 自己登録が使えない会社では、陸上に配乗の登録を頼むよう案内する。
 */
import React, { useState } from 'react';
import { apiFetch } from '../services/api';
import { hasFeature } from '../utils/featureFlags';

export const BoardingRequiredCard: React.FC<{ vesselId: string; vesselName: string; onBoarded: () => void }> = ({ vesselId, vesselName, onBoarded }) => {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const canSelfBoard = hasFeature('crew_self_boarding');

  const board = async () => {
    if (!window.confirm(`「${vesselName}」に乗船したことを登録します。\n（陸上の管理者へ通知されます）`)) return;
    setBusy(true); setErr('');
    try {
      await apiFetch('/self-boarding/board', { method: 'POST', body: JSON.stringify({ vessel_id: vesselId }) });
      onBoarded();
    } catch (e: any) { setErr(e?.message ?? '登録に失敗しました'); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ width: '100%', marginTop: 10, background: '#fffbeb', border: '1.5px solid #fde68a', borderRadius: 14, padding: '14px 16px', textAlign: 'left' }}>
      <div style={{ fontSize: 14, fontWeight: 800, color: '#92400e', marginBottom: 4 }}>⚠️ {vesselName} への乗船登録がありません</div>
      <div style={{ fontSize: 12, color: '#a16207', lineHeight: 1.6, marginBottom: 10 }}>
        {canSelfBoard
          ? '勤怠を付けるには、先にこの船への乗船を登録してください（陸上の管理者へ通知されます）。'
          : '勤怠を付けるには、この船への配乗（乗船）の登録が必要です。陸上の管理者に登録を依頼してください。'}
      </div>
      {canSelfBoard && (
        <button onClick={board} disabled={busy}
          style={{ width: '100%', padding: '14px 8px', borderRadius: 12, border: 'none', fontSize: 15, fontWeight: 800,
            background: busy ? '#e2e8f0' : 'linear-gradient(145deg,#0057d9,#003fa3)', color: busy ? '#94a3b8' : '#fff',
            cursor: busy ? 'not-allowed' : 'pointer' }}>
          {busy ? '登録中…' : `🚢 ${vesselName} に乗船登録する`}
        </button>
      )}
      {err && <div style={{ fontSize: 12, color: '#dc2626', fontWeight: 700, marginTop: 10 }}>{err}</div>}
    </div>
  );
};
